"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var react_1 = __importStar(require("react"));
var react_date_picker_1 = __importDefault(require("react-date-picker"));
var styled_components_1 = __importStar(require("styled-components"));
var timers_1 = require("timers");
var utils_1 = require("../Form/utils");
var CalendarIcon_1 = __importDefault(require("./CalendarIcon"));
var StyledDatePicker = styled_components_1.default(react_date_picker_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px solid #686868;\n  border-radius: 3px;\n  font-size: 15px;\n  padding: 10px;\n  height: 50px;\n  text-overflow: ellipsis;\n  outline: none;\n  background-color: #fff;\n  .react-date-picker__wrapper {\n    border: none;\n    align-items: center;\n  }\n  .react-date-picker__button {\n    padding: 0px 6px;\n  }\n  .react-date-picker__calendar {\n    top: 100% !important;\n    bottom: 0% !important;\n    z-index: 1000 !important;\n  }\n  input {\n    -moz-appearance: textfield !important;\n  }\n\n  ", "\n\n  ", ";\n\n  @media only screen and (max-width: 640px) {\n    width: 100%;\n  }\n\n  ", "\n"], ["\n  border: 1px solid #686868;\n  border-radius: 3px;\n  font-size: 15px;\n  padding: 10px;\n  height: 50px;\n  text-overflow: ellipsis;\n  outline: none;\n  background-color: #fff;\n  .react-date-picker__wrapper {\n    border: none;\n    align-items: center;\n  }\n  .react-date-picker__button {\n    padding: 0px 6px;\n  }\n  .react-date-picker__calendar {\n    top: 100% !important;\n    bottom: 0% !important;\n    z-index: 1000 !important;\n  }\n  input {\n    -moz-appearance: textfield !important;\n  }\n\n  ",
    "\n\n  ", ";\n\n  @media only screen and (max-width: 640px) {\n    width: 100%;\n  }\n\n  ",
    "\n"])), function (_a) {
    var $readOnly = _a.$readOnly;
    return $readOnly && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #f5f5f5;\n      border: 1px solid #a8a8a8;\n    "], ["\n      background-color: #f5f5f5;\n      border: 1px solid #a8a8a8;\n    "])));
}, function (_a) {
    var $size = _a.$size;
    return utils_1.getInputSizeStyles($size);
}, function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-radius: 4px;\n      border: 2px solid #ba0d23;\n    "], ["\n      border-radius: 4px;\n      border: 2px solid #ba0d23;\n    "])));
});
var CloseIcon = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: #005285;\n  font-size: 16px;\n  margin-top: 5px;\n"], ["\n  color: #005285;\n  font-size: 16px;\n  margin-top: 5px;\n"])));
var DatePicker = function (_a) {
    var onChange = _a.onChange, className = _a.className, readOnly = _a.readOnly, size = _a.size, minDate = _a.minDate, maxDate = _a.maxDate, name = _a.name, value = _a.value, defaultValue = _a.defaultValue, clearIcon = _a.clearIcon, hasError = _a.hasError, defaultActiveStartDate = _a.defaultActiveStartDate;
    var ref = react_1.useRef(null);
    var _b = react_1.useState(), calendarClose = _b[0], setCalendarClose = _b[1];
    var _c = react_1.useState(), dateValue = _c[0], setDateValue = _c[1];
    react_1.useEffect(function () {
        setDateValue(value ? new Date(value) : undefined);
    }, [value]);
    var handleChange = function (d) {
        setCalendarClose(true);
        if (Array.isArray(d)) {
            return;
        }
        return onChange(d);
    };
    var handleOnCalendarOpen = function () {
        setCalendarClose(true);
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    };
    window.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            setCalendarClose(false);
        }
    });
    var handleClose = function () {
        setDateValue(new Date());
        var timeOut = timers_1.setTimeout(function () {
            setDateValue(value ? new Date(value) : undefined);
        }, 1);
        return function () { return clearTimeout(timeOut); };
    };
    return (react_1.default.createElement("div", { className: className, ref: ref },
        react_1.default.createElement(StyledDatePicker, { name: name, onCalendarOpen: handleOnCalendarOpen, onChange: handleChange, value: dateValue, defaultValue: defaultValue, disabled: readOnly, "$size": size, "$readOnly": readOnly, minDate: minDate || new Date('1000-01-01'), maxDate: maxDate || new Date('9999-12-31'), defaultActiveStartDate: defaultActiveStartDate, locale: "cs", isOpen: calendarClose, onCalendarClose: function () { return handleClose(); }, clearIcon: clearIcon === null ? null : clearIcon || react_1.default.createElement(CloseIcon, null), "$hasError": hasError, calendarIcon: readOnly ? null : react_1.default.createElement(CalendarIcon_1.default, null) })));
};
DatePicker.defaultProps = {
    className: undefined,
    isDisabled: undefined,
    size: undefined,
    readOnly: false,
    minDate: undefined,
    maxDate: undefined,
    value: undefined,
    defaultValue: undefined,
    clearIcon: undefined,
    hasError: false,
    defaultActiveStartDate: undefined,
};
exports.default = styled_components_1.default(DatePicker)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
